import { LABELS } from "./format";

export const OPTIONS = {
  classification: Object.entries(LABELS.classification).map(([value, label]) => ({ value, label })),
  contact_type: Object.entries(LABELS.contact_type).map(([value, label]) => ({ value, label })),
  contact_status: Object.entries(LABELS.contact_status).map(([value, label]) => ({ value, label })),
  lead_status: Object.entries(LABELS.lead_status).map(([value, label]) => ({ value, label })),
  activity_type: Object.entries(LABELS.activity_type).map(([value, label]) => ({ value, label })),
  activity_status: Object.entries(LABELS.activity_status).map(([value, label]) => ({ value, label })),
  priority: Object.entries(LABELS.priority).map(([value, label]) => ({ value, label })),
  project_status: Object.entries(LABELS.project_status).map(([value, label]) => ({ value, label })),
  opp_status: Object.entries(LABELS.opp_status).map(([value, label]) => ({ value, label })),
  role: Object.entries(LABELS.role).map(([value, label]) => ({ value, label })),
};

// Select lists (sector, country, source, …) are editable lookups served by /api/lookups (see lib/lookups.js).
// relation keys always allowed through FormDialog even when not rendered as fields
export const RELATION_KEYS = ["company_id", "contact_id", "opportunity_id", "lead_id", "pipeline_id", "stage_id", "project_id"];

export const ENGAGEMENT = ["nessuno", "basso", "medio", "alto"].map((e) => ({ value: e, label: e }));

export const COMPANY_FIELDS = [
  { name: "legal_name", label: "Ragione sociale", type: "text", full: true, required: true },
  { name: "trade_name", label: "Nome commerciale", type: "text" },
  { name: "classification", label: "Classificazione", type: "select", options: OPTIONS.classification },
  { name: "relationship_status", label: "Stato relazione", type: "select", options: OPTIONS.contact_status },
  { name: "committente", label: "Committente", type: "committente" },
  { name: "vat_number", label: "Partita IVA / Codice fiscale", type: "text" },
  { name: "website", label: "Sito web", type: "text" },
  { name: "linkedin_url", label: "LinkedIn Company URL", type: "text" },
  { name: "email", label: "Email generale", type: "text" },
  { name: "phone", label: "Telefono", type: "text" },
  { name: "address", label: "Indirizzo", type: "text" },
  { name: "postal_code", label: "CAP", type: "text" },
  { name: "city", label: "Città", type: "text" },
  { name: "region", label: "Regione / Provincia", type: "text" },
  { name: "country", label: "Paese", type: "lookup", lookup: "country" },
  { name: "sector", label: "Settore", type: "lookup", lookup: "sector" },
  { name: "subsector", label: "Sottosettore", type: "lookup", lookup: "subsector" },
  { name: "ateco", label: "Codice ATECO/NACE", type: "ateco" },
  { name: "employees", label: "Numero dipendenti", type: "lookup", lookup: "employee_band" },
  { name: "revenue_band", label: "Fascia fatturato", type: "lookup", lookup: "revenue_band" },
  { name: "export_markets", label: "Mercati export", type: "tags" },
  { name: "source", label: "Fonte acquisizione", type: "lookup", lookup: "source" },
  { name: "owner_id", label: "Owner / Responsabile", type: "user" },
  { name: "rating", label: "Rating / Priority", type: "select", options: [{ value: "A", label: "A - Alta" }, { value: "B", label: "B - Media" }, { value: "C", label: "C - Bassa" }] },
  { name: "tags", label: "Tags", type: "tags", full: true },
  { name: "notes", label: "Note", type: "textarea", full: true },
];

export const CONTACT_FIELDS = [
  { name: "first_name", label: "Nome", type: "text", required: true },
  { name: "last_name", label: "Cognome", type: "text", required: true },
  { name: "job_title", label: "Job Title", type: "text" },
  { name: "department", label: "Dipartimento", type: "lookup", lookup: "department" },
  { name: "function", label: "Funzione", type: "text" },
  { name: "seniority", label: "Seniority", type: "lookup", lookup: "seniority" },
  { name: "decision_maker", label: "Decision Maker", type: "switch" },
  { name: "company_id", label: "Azienda", type: "company" },
  { name: "contact_type", label: "Tipologia contatto", type: "select", options: OPTIONS.contact_type },
  { name: "committente", label: "Committente", type: "committente" },
  { name: "relationship_status", label: "Relationship status", type: "select", options: OPTIONS.contact_status },
  { name: "email", label: "Email", type: "text" },
  { name: "email_secondary", label: "Email secondaria", type: "text" },
  { name: "phone", label: "Telefono", type: "text" },
  { name: "mobile", label: "Mobile", type: "text" },
  { name: "linkedin_url", label: "LinkedIn URL", type: "text" },
  { name: "sales_navigator_url", label: "Sales Navigator URL", type: "text" },
  { name: "city", label: "Città", type: "text" },
  { name: "region", label: "Regione", type: "text" },
  { name: "country", label: "Paese", type: "lookup", lookup: "country" },
  { name: "language", label: "Lingua", type: "text" },
  { name: "source", label: "Fonte", type: "lookup", lookup: "source" },
  { name: "owner_id", label: "Owner / Responsabile", type: "user" },
  { name: "next_followup", label: "Prossimo follow-up", type: "date" },
  { name: "tags", label: "Tags", type: "tags", full: true },
  { name: "notes", label: "Note", type: "textarea", full: true },
];

export const LEAD_FIELDS = [
  { name: "title", label: "Titolo lead", type: "text", full: true, required: true, placeholder: "Es. Analisi mercato USA – form sito" },
  { name: "company_id", label: "Azienda", type: "company" },
  { name: "contact_id", label: "Contatto", type: "contact" },
  { name: "committente", label: "Committente", type: "committente" },
  { name: "status", label: "Stato", type: "select", options: OPTIONS.lead_status },
  { name: "source", label: "Fonte", type: "lookup", lookup: "source" },
  { name: "owner_id", label: "Owner / Responsabile", type: "user" },
  { name: "market", label: "Mercato", type: "lookup", lookup: "country" },
  { name: "service", label: "Servizio", type: "lookup", lookup: "service" },
  { name: "score_mode", label: "Modalità punteggio", type: "select", options: [{ value: "auto", label: "Automatico" }, { value: "manual", label: "Manuale" }] },
  { name: "score", label: "Score manuale (0-100)", type: "number" },
  { name: "decision_maker", label: "Decision Maker", type: "switch" },
  { name: "seniority", label: "Seniority", type: "lookup", lookup: "seniority" },
  { name: "company_size", label: "Dimensione azienda", type: "lookup", lookup: "employee_band" },
  { name: "engagement", label: "Engagement", type: "select", options: ENGAGEMENT },
  { name: "interactions", label: "N. interazioni", type: "number" },
  { name: "tags", label: "Tags", type: "tags", full: true },
  { name: "notes", label: "Note", type: "textarea", full: true },
];

export const OPPORTUNITY_FIELDS = [
  { name: "name", label: "Nome opportunità", type: "text", full: true, required: true },
  { name: "company_id", label: "Azienda", type: "company" },
  { name: "contact_id", label: "Contatto principale", type: "contact" },
  { name: "committente", label: "Committente", type: "committente" },
  { name: "pipeline_id", label: "Pipeline", type: "pipeline" },
  { name: "stage_id", label: "Fase", type: "stage" },
  { name: "value", label: "Valore economico (€)", type: "number" },
  { name: "probability", label: "Probabilità %", type: "number" },
  { name: "service", label: "Servizio", type: "lookup", lookup: "service" },
  { name: "market", label: "Mercato", type: "lookup", lookup: "country" },
  { name: "source", label: "Fonte", type: "lookup", lookup: "source" },
  { name: "owner_id", label: "Owner / Responsabile", type: "user" },
  { name: "close_date", label: "Data chiusura prevista", type: "date" },
  { name: "next_step", label: "Next Step", type: "text", full: true },
  { name: "competitor", label: "Competitor", type: "text" },
  { name: "tags", label: "Tags", type: "tags", full: true },
  { name: "notes", label: "Note / Motivazione", type: "textarea", full: true },
];

export const ACTIVITY_FIELDS = [
  { name: "subject", label: "Oggetto", type: "text", full: true, required: true },
  { name: "type", label: "Tipo", type: "select", options: OPTIONS.activity_type },
  { name: "priority", label: "Priorità", type: "select", options: OPTIONS.priority },
  { name: "company_id", label: "Azienda", type: "company" },
  { name: "contact_id", label: "Contatto", type: "contact" },
  { name: "opportunity_id", label: "Opportunità", type: "opportunity" },
  { name: "lead_id", label: "Lead", type: "lead" },
  { name: "committente", label: "Committente", type: "committente" },
  { name: "due_date", label: "Data e ora inizio", type: "datetime" },
  { name: "end_date", label: "Data e ora fine", type: "datetime" },
  { name: "all_day", label: "Tutto il giorno", type: "switch" },
  { name: "duration", label: "Durata (min)", type: "number" },
  { name: "location", label: "Luogo", type: "text" },
  { name: "online_meeting_url", label: "Link meeting online (Teams/Zoom/Meet)", type: "text" },
  { name: "attendees", label: "Partecipanti (email)", type: "tags", full: true },
  { name: "project_id", label: "Progetto", type: "project" },
  { name: "status", label: "Stato", type: "select", options: OPTIONS.activity_status },
  { name: "reminder_offsets", label: "Promemoria email e notifica CRM", type: "reminders", full: true },
  { name: "recurrence_freq", label: "Ricorrenza", type: "select", options: [{ value: "none", label: "Nessuna" }, { value: "daily", label: "Giornaliera" }, { value: "weekly", label: "Settimanale" }, { value: "monthly", label: "Mensile" }] },
  { name: "recurrence_until", label: "Ripeti fino al", type: "date" },
  { name: "notes", label: "Note", type: "textarea", full: true },
];
